<div class="body-home">
  <div class="center-wrapper">
    <div class="iris-logo-wrapper">
      <img src="../../../assets/logo-iris.png" alt="Logo IRIS" class="iris-logo">
    </div>

    <div class="overlay">
      <button class="card-button" routerLink="/login-google" routerLinkActive="active">
        <svg class="card-icon" viewBox="0 0 24 24">
          <path d="M12,1A11,11 0 0,0 1,12A11,11 0 0,0 12,23A11,11 0 0,0 23,12A11,11 0 0,0 12,1M12,3A9,9 0 0,1 21,12A9,9 0 0,1 12,21A9,9 0 0,1 3,12A9,9 0 0,1 12,3M12,6A3,3 0 0,0 9,9V10A1,1 0 0,0 8,11V16A1,1 0 0,0 9,17H15A1,1 0 0,0 16,16V11A1,1 0 0,0 15,10V9A3,3 0 0,0 12,6M12,7A2,2 0 0,1 14,9V10H10V9A2,2 0 0,1 12,7Z"/>
        </svg>
        <h2>Desbloquea tu cuenta de red</h2>
        <p>Para acceder a Windows, VPN, Internet Iris_Corp</p>
      </button>

      <button class="card-button" routerLink="/login" routerLinkActive="active">
        <div class="iris-logo-wrapper">
          <img src="../../../assets/logoBoris.png" alt="Logo IRIS" class="iris-logo">
        </div>
        <h2>Gestión clientes</h2>
        <p>Experiencia al cliente personalizada y eficiente</p>
      </button>
    </div>
  </div>
</div>
